module.exports = __webpack_public_path__ + "static/media/search.424e3bad.svg";